'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _filter2 = require('./internal/_filter');

var _filter3 = _interopRequireDefault(_filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Remove values for which `predicate` returns `false`.
 *
 * @example
 * // returns List [ 2 ]
 * filter(
 *   (n) => n % 2 === 0,
 *   List.of(1, 2, 3)
 * );
 *
 * @example <caption>`Record`s have a fixed set of keys, so filter returns a Map instead.</caption>
 * // returns Map { 'one' => 1, 'three' => 3 }
 * filter(
 *   (n) => n % 2 === 0,
 *   ThreeRecord({one: 1, two: 2, three: 3})
 * );
 *
 * @param {Function} predicate returns `true` if a value should be included.
 * @param {Iterable} subject to filter.
 * @return {Iterable} without values that didn't match `predicate`.
 */
exports.default = (0, _curry2.default)(_filter3.default);
module.exports = exports['default'];